import React from "react";
import VisitorStaffMetricCards from "./VisitorStaffMetricCards";

/**
 * Live summary cards for staff visitor screens (updates on save, focus, poll).
 */
export default function VisitorLiveStatsPanel({
  sectionId = "visitor-stats",
  loading,
  dashboardStats,
  title = "Summary",
  hint = "Live counts for your visitor entries on this page.",
}) {
  return (
    <section
      id={sectionId}
      className="user-builder-panel"
      style={{ scrollMarginTop: "2rem" }}
    >
      <div className="user-builder-panel__head">
        <h3 className="user-builder-panel__title">{title}</h3>
        <p className="user-builder-panel__hint">{hint}</p>
      </div>
      <VisitorStaffMetricCards loading={loading} dashboardStats={dashboardStats} />
    </section>
  );
}
